import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
  standalone: true,
})
export class SafeHtmlPipe implements PipeTransform {
  private readonly html = inject(DomSanitizer);

  public transform(html: string): SafeHtml {
    return this.html.bypassSecurityTrustHtml(html);
  }
}
